import React from 'react';
import PropTypes from 'prop-types';
import s from './TwoColumnDataValue.module.scss';
import SingleDataValueItem from '../SingleDataValueItem';
import Box from '../Box/Box';
import Grid from '../Grid/Grid';

const TwoColumnDataValue = ({
    modifier,
    title,
    description,
    value,
    unit,
    children,
    asItem = false,
}) => {
    return (
        <Box className={s.Root} modifier={modifier}>
            <div className={s.Grid}>
                <div className={s.Left}>
                    {asItem ? (
                        <SingleDataValueItem
                            title={title}
                            description={description}
                            value={value}
                            unit={unit}
                        />
                    ) : (
                        <SingleDataValueItem
                            title={title}
                            description={description}
                            value={value}
                            unit={unit}
                        />
                    )}
                </div>
                <div className={s.Right}>{children}</div>
            </div>
        </Box>
    );
};

TwoColumnDataValue.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    value: PropTypes.string,
    unit: PropTypes.string,
    children: PropTypes.node,
};

export default TwoColumnDataValue;
